import React, { FC } from "react";
import LogoLArge from "shared/Logo/LogoLarge";
import MenuBar from "shared/MenuBar/MenuBar";
import AvatarDropdown from "./AvatarDropdown2";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import texture from "images/bg_Texture5.png";
import { useAuth0 } from "@auth0/auth0-react";


export interface MainNav3Props {
  className?: string;
}

const MainNav3: FC<MainNav3Props> = ({
  className = "",
}) => {
  const { loginWithRedirect, logout } = useAuth0();

  function gotoLogin() {
  }

  const handleButtonClick = () => {
    window.location.href = "https://blog.paradiseliving.homes/";
  };

  const logoutWithRedirect = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  };

  const { user, isAuthenticated } = useAuth0();



  return (
    <div className="relative h-[97px]">
      <div className={`absolute left-0 top-0  ${className} opacity-50  w-full  h-full z-0`} style={{
        backgroundImage: `url(${texture})`,
        backgroundSize: 'auto',
        backgroundRepeat: 'repeat',
      }}>
      </div>

      <div className="relative h-full">
        <div className="hidden lg:flex justify-left flex-1 items-center absolute inset-0 z-0 pl-[70px]">
          <div className="flex">
            <LogoLArge />
          </div>
        </div>
        <div className="h-full flex lg:hidden justify-left flex-1 items-center absolute inset-0 z-0 pl-[20px]">
          <div className="flex">
            <LogoLArge className="w-[200px]" />
          </div>
        </div>

        <div className=" h-full flex justify-end items-center lg:hidden z-10 pr-[20px]">
          <HeroSearchForm2MobileFactory />
        </div>

        <div className="hidden lg:flex h-full items-center justify-end lg:flex-none text-neutral-700 z-10 pr-[80px] md:pr-[20px] ">
          <div className="flex space-x-4">
            <button className="text-sm font-semibold" style={{ zIndex: 10 }} onClick={handleButtonClick}>BLOG</button>
            <button className="text-sm font-semibold px-4" style={{ zIndex: 10 }}>ABOUT US</button>
            {!isAuthenticated && (
              <button className="bg-[#00D3DB] rounded-md h-7 text-sm font-semibold text-white px-4" style={{ zIndex: 10 }} onClick={() => loginWithRedirect()}>Log In</button>
            )}
            {isAuthenticated && <AvatarDropdown logoutClick={logoutWithRedirect} />}
          </div>
          <div style={{ zIndex: 10 }}>
          <MenuBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav3;